let QQLiveHintPanel = xClass("QQLiveHintPanel", BasePanel, 
        () => {
            let rootNode = cc.Sprite.create()
            return rootNode
    })


QQLiveHintPanel.prototype.ctor =  function (onCloseCallback){
    let self = this;
    BasePanel.prototype.ctor.call(self);
    self.onCloseCallback = onCloseCallback;
}

QQLiveHintPanel.prototype.initHintPanel =  function (){
    let self = this;
    
    let hintLabel = cc.Label.createWithSystemFont("游戏只支持竖屏，请切换为竖屏", "Arial", 30)
    self.addChild(hintLabel)
    hintLabel.setAnchorPoint(0.5, 0.5)
    hintLabel.setLocalZOrder()
    let ratio = display.height / GamePlayConfig_Design_Height
    hintLabel.setPosition(0, 200)
    //hintLabel.setPosition(GamePlayConfig_Design_Width*ratio, GamePlayConfig_Design_Height*ratio)
}

QQLiveHintPanel.prototype.popup = function (dark, canTouchBehind, callback) {
    var self = this
    self.isClosed = false
    PopoutManager.getInstance().addWithBgFadeIn(self, dark, canTouchBehind)  
    if (callback) {
        callback()
    }
    var vSize = cc.Director.getInstance().getVisibleSize()
    self.setPosition(vSize.width / 2, vSize.height / 2)
    return self
}

QQLiveHintPanel.prototype.closePanel = function (){
    let self = this;
    BasePanel.prototype.onClose.call(self, self.onCloseCallback, null, true)
}

var _qqLiveHintPanel = QQLiveHintPanel.create()
_qqLiveHintPanel.initHintPanel()

module.exports = _qqLiveHintPanel;